import React, { useCallback, useEffect, useRef, useState } from 'react'
import DOMPurify from 'dompurify';
import Trianglify from 'trianglify/dist/trianglify.bundle.js';
import debounce from 'lodash/debounce.js'

import classes from "./Triangles.module.css";

export default function Triangles() {
  const [svg, setSvg] = useState(null);
  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const updateWindowDimensions = () => {
      setHeight(window.innerHeight);
      setWidth(window.innerWidth);
    };
    const updateWindowDimensionsDebounced = debounce(updateWindowDimensions, 150);

    window.addEventListener("resize", updateWindowDimensionsDebounced);

    return () => window.removeEventListener("resize", updateWindowDimensionsDebounced);
  }, []);

  useEffect(() => {
    // https://github.com/qrohlf/trianglify?tab=readme-ov-file#-configuration
    // https://github.com/qrohlf/trianglify/blob/b959ccd656ca7294ebe363ee0c1dfbe72929a16e/examples/color-function-example.html
    const pattern = Trianglify({
      cellSize: 80,
      variance: 1,
      seed: 'hello',
      xColors: ['#1c1c1c', '#040404', '#1a1a1a', '#0a0a0a', '#111111', '#101010', '#151515', '#0f0f0f'],
      yColors: 'match',
      // xColors: 'random', // match
      // yColors: 'random',
      // palette: ['#000000', '#999999', '#2d2d2d', '#111111'],
      width,
      height,
      colorFunction: Trianglify.colorFunctions.sparkle(1)
    });

    const svg = pattern.toSVG();

    setSvg(DOMPurify.sanitize(
      svg,
      {USE_PROFILES: {svg: true}}
    ));
  }, [height, width, setSvg]);

  if (!svg) return;

  return (
    <div
      className={classes.triangles}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
